import compose from 'recompose/compose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { lifecycle } from 'recompose';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import moment from 'moment-timezone';
import { t } from '../../../modules/infra/i18n';
import CampaignPayActions from '../components/CampaignPayActions';
import {
  getCampaignCharge,
} from '../selectors';
import {
  chargeCampaign,
  redirectToCampaignList,
  setScheduledAt,
  setRecurringTime,
  setRecurringStartDate,
  setRecurringEndDate,
  setRecurringFreqeuncy,
  setRecurringSendToAllCustomers,
} from '../actions';
import { getTimezone, getActiveType } from '../../auth/selectors';
import withNotifications from '../../common/withNotifications';
import withToggle from '../../common/hoc/withToggle';
import { DEFAULT_TIME } from '../constants';
import config from '../../../config';

const getDefaultDate = () => moment().format(config.dateFormatISO);
const getDefaultTime = () => DEFAULT_TIME;
const getDateTimeFromDateAndTime = (date, time, timezone) => {
  const timeMoment = moment(time, config.timeFormat);
  return moment.tz(date, config.dateFormatISO, timezone)
    .hours(timeMoment.hours())
    .minutes(timeMoment.minutes())
    .toISOString();
};

const getDateFromDate = (date, time, timezone) => moment.tz(date, config.dateFormatISO, timezone).format('YYYY-MM-DD');

const CampaignPayActionsContainer = compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      campaignId: ownProps.params.campaignId,
      campaignCharge: getCampaignCharge(state),
      timezone: getTimezone(state),
      activeType: getActiveType(state),
      date: getDefaultDate(),
      campaignType: state.engagement.campaign.type,
      isLapsedCampaign: state.engagement.campaign.customerGroups.length === 1
        && state.engagement.campaign.customerGroups[0].name === 'lapsing',
    }),
    {
      chargeCampaign,
      redirectToCampaignList,
      setScheduledAt,
      setRecurringTime,
      setRecurringStartDate,
      setRecurringEndDate,
      setRecurringFreqeuncy,
      setRecurringSendToAllCustomers,
    },
  ),
  withNotifications,
  withToggle('schedule'),
  withToggle('submitting', false),
  withState('date', 'setDate', getDefaultDate()),
  withState('startDate', 'setStartDate', getDefaultDate()),
  withState('endDate', 'setEndDate', moment(getDefaultDate()).add(1, 'M').format('YYYY-MM-DD')),
  withState('time', 'setTime', getDefaultTime()),
  withHandlers({
    onDateChange: props => (date) => {
      props.setDate(date);
      props.setScheduledAt(getDateTimeFromDateAndTime(date, props.time, props.timezone));
      props.setRecurringTime(getDateTimeFromDateAndTime(date, props.time, props.timezone));
    },
    onTimeChange: props => (e) => {
      props.setTime(e.target.value);
      props.setScheduledAt(getDateTimeFromDateAndTime(props.date, e.target.value, props.timezone));
      props.setRecurringTime(getDateTimeFromDateAndTime(props.date, e.target.value, props.timezone));
    },
    onDateStartChange: props => (date) => {
      props.setStartDate(date);
      props.setScheduledAt(getDateTimeFromDateAndTime(props.date, date, props.timezone));
      props.setRecurringStartDate(getDateFromDate(date, props.time, props.timezone));
    },
    onDateEndChange: props => (date) => {
      props.setEndDate(date);
      if (date === null) {
        props.setRecurringEndDate(null);
      } else {
        props.setRecurringEndDate(getDateFromDate(date, props.time, props.timezone));
      }
    },
    onRecurringTimeChange: props => (time) => {
      props.setRecurringTime(time);
    },
    onFrequencyChange: props => (frequency) => {
      props.setRecurringFreqeuncy(frequency);
    },
    onRecurringSendToAllCustomers: props => (value) => {
      props.setRecurringSendToAllCustomers(value);
    },
  }),
  withHandlers({
    chargeCampaign: props => () => props.chargeCampaign(props.campaignId, props.campaignCharge)
    .then(() => {
      props.addNotification({
        title: t('engage:notifications.success'),
        level: 'success',
        message: t('engage:notifications.campaign_charged'),
      });
      props.redirectToCampaignList(props.activeType);
    }),
  }),
  withHandlers({
    onPayNowClick: props => () => {
      props.submittingOn();
      return props.chargeCampaign()
        .then(() => props.submittingOff())
        .catch(() => props.submittingOff());
    },
    onScheduleClick: props => () => {
      props.setScheduledAt(moment.tz(DEFAULT_TIME, config.timeFormat, props.timezone).toISOString());
      props.setRecurringTime(moment.tz(DEFAULT_TIME, config.timeFormat, props.timezone).toISOString());
      props.scheduleOn();
    },
    onRecurringScheduleClick: props => () => {
      props.setRecurringTime(moment.tz(DEFAULT_TIME, config.timeFormat, props.timezone).toISOString());
      props.scheduleOn();
    },
    scheduleCampaign: props => () => {
      props.submittingOn();
      return props.chargeCampaign()
        .then(() => props.submittingOff())
        .catch(() => props.submittingOff());
    },
    closeSchedule: props => () => {
      props.setScheduledAt(null);
      props.setRecurringTime(null);
      props.scheduleOff();
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.onRecurringTimeChange(moment(this.props.time).format('HH:mm'));
    },
  })
)(CampaignPayActions);

export default CampaignPayActionsContainer;
